import { type MutationHookOptions, useMutation } from "@apollo/client";
import { UpdateContentManyMutation } from "../graphql/mutations";
import type {
  UpdateContentManyMutationType,
  UpdateContentManyMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useUpdateContentManyMutation = (
  options?: MutationHookOptions<
    UpdateContentManyMutationType,
    UpdateContentManyMutationVariablesType
  >
) => {
  return useMutation<
    UpdateContentManyMutationType,
    UpdateContentManyMutationVariablesType
  >(UpdateContentManyMutation, options);
};
